<template>
  <div>
    <b-button
      v-if="!isView"
      class="btn-custom px-5 mb-3"
      variant="info"
      size="sm"
      @click="addRowInstallment"
    >
      Add
    </b-button>
    <b-table
      thead-class="bg-color text-center"
      tbody-class="table-body"
      tfoot-class="table-body text-center"
      empty-text="No data"
      :items="form.bup_others_installment"
      :fields="installmentFields"
      show-empty
      responsive
      bordered
      foot-clone
    >
      <template v-slot:cell(description)="{ item }">
        <validation-provider
          name="Description Installment"
          rules="required"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-input
            v-model="item.description"
            autocapitalize="off"
            placeholder="Enter Description"
            size="sm"
            :class="{ 'is-invalid': errors.length }"
            :invalid-feedback="errors[0]"
            :disabled="isView"
          />
        </validation-provider>
      </template>
      <template v-slot:cell(amount)="{ item }">
        <validation-provider
          name="Amount Installment"
          rules="required|min_value:1"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-input
            v-model="item.amount"
            autocapitalize="off"
            placeholder="Enter Amount"
            type="number"
            size="sm"
            :class="{ 'is-invalid': errors.length }"
            :invalid-feedback="errors[0]"
            :disabled="isView"
          />
        </validation-provider>
      </template>
      <template v-slot:cell(actions)="{ index }">
        <b-button
          v-if="!isView && form.bup_others_installment.length > 1"
          variant="link"
          class="text-decoration-none text-danger p-0"
          @click="removeInstallment(index)"
        >
          <fa-icon icon="times-circle" />
        </b-button>
      </template>
      <template #foot(description)>
        Total
      </template>
      <template #foot(amount)>
        {{ formatMoney(subTotal(form.bup_others_installment), { symbol: '', precision: '2', thousand: ',' }) }}
      </template>
    </b-table>
    <br>

    <h6 class="font-weight-bold">Attachment Supporting Document</h6>
    <div v-if="!isView" class="mt-4">
      <div>
        <div class="dropbox">
          <input
            type="file"
            @change="onChangeFile($event.target.files)"
            class="input-file"
            multiple
            accept=".xls, .xlsx, .doc, .docx, .pdf"
          >
            <img
              class="mt-2"
              src="@/assets/icon-upload.png"
              width="100"
              height="100"
            >
            <div>
              <p id="text-dropbox">Drag or klik button to upload file</p>
            </div>
            <b-button
              class="btn-custom"
              variant="info"
              size="sm"
            >
              Browse File
            </b-button>
        </div>
      </div>
    </div>
    <div
      v-if="attachmentInstallment.length"
      :style="gridStyle"
      class="card-list mt-2 p-0"
      id="attachment"
    >
      <div
        v-for="(item, index) in attachmentInstallment"
        :key="index"
        class="supporting-file"
      >
        <div
          class="dropbox-files mx-1 mb-2"
        >
          <div
            v-if="item.file_name"
            class="background-file"
          >
            <div class="d-flex justify-content-end">
              <img
                v-if="!isView"
                class="mr-2 mt-2"
                src="@/assets/icon-trash.png"
                width="25"
                height="25"
                style="cursor: pointer"
                @click="removeFile(index, item.id)"
              >
            </div>
            <div class="pointer" @click="downloadFile(item)">
              <img
                v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-excel.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[4]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-pdf.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-word.png"
                width="70"
                height="70"
              >
            </div>
          </div>
          <div
            class="text mt-2"
          >
            <span class="text-ellipsis mx-2">{{ item ? item.file_name : 'NaN'}}</span>
            <span class="size-file">{{ item ? item.size : 'NaN mb'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isView && !attachmentInstallment.length" class="w-100 text-center">No Attachment</div>
  </div>
</template>

<script>
import api from '@/api'
import { formatMoney } from 'accounting-js'

export default {
  props: {
    isView: {
      types: Boolean,
      default: false
    },
    isEdit: {
      types: Boolean,
      default: false
    },
    form: {
      types: Object,
      default: () => {}
    }
  },

  components: {},

  data: () => ({
    installmentFields: [
      { key: 'description', label: 'Description', tdClass: 'text-center' },
      { key: 'amount', label: 'Amount (IDR)', tdClass: 'text-center' },
      { key: 'actions', tdClass: 'text-center', thStyle: 'width: 75px' }
    ],
    numberOfColumns: 4,
    attachmentInstallment: [],
    attachmentType: ['xlsx', 'xls', 'doc', 'docx', 'pdf'],
    isUpload: false,
    upload: {
      progress: 0,
      variant: 'success'
    }
  }),

  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(25%, 1fr))`
      }
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.fetchAttachment()
    }
  },

  methods: {
    formatMoney,
    async fetchAttachment() {
      this.attachmentInstallment = await api.other.getAttachment(this.$route.params.id, 'Installment')
    },
    addRowInstallment() {
      this.form.bup_others_installment.push({
        description: '',
        amount: ''
      })
    },
    removeInstallment(index) {
      this.form.bup_others_installment = [
        ...this.form.bup_others_installment.slice(0, index),
        ...this.form.bup_others_installment.slice(index + 1)
      ]
    },
    async onChangeFile(value) {
      let isTypeAllowed = true
      let isSizeAllowed = true
      if (value.length + this.attachmentInstallment.length > 10) {
        this.$nextTick(() => {
          this.$bvToast.toast('maximum file to upload only 10 files', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
        return
      }
      const formData = new FormData()
      for (let i = 0; i < value.length; i++) {
        const nameFile = value[i].name.split('.')
        if ((this.attachmentType.includes(nameFile[nameFile.length - 1]))) {
          if (value[i].size < 3072000) {
            formData.append('bup_others_file', value[i])
          } else {
            isSizeAllowed = false
            break
          }
        } else {
          isTypeAllowed = false
          break
        }
      }
      if (!isTypeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Only PDF, Excel and Doc files are allowed.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }

      if (!isSizeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Max size file 3 mb.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      if (isTypeAllowed && isSizeAllowed) {
        await this.uploadAttachment(formData, value)
      }
    },
    async uploadAttachment(formData, value) {
      try {
        const data = await api.other
          .uploadAttachment(
            this.$route.params.id ? this.$route.params.id : 0,
            'Installment',
            formData,
            { onUploadProgress: this.setUploadProgress }
          )
        if (!this.$route.params.id) {
          data[0].map(v => {
            this.form.attachmentInstallmentId.push(v)
          })
          for (const file of Object.entries(value)) {
            this.attachmentInstallment.push({
              file_name: file[1].name,
              size: this.formatBytes(file[1].size),
              url: file[1],
              id: null
            })
          }
          this.form.attachmentInstallmentId.map((v, i) => {
            this.attachmentInstallment[i].id = v
          })
        } else {
          setTimeout(() => this.fetchAttachment(), 1500)
        }
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    setUploadProgress({ loaded }) {
      this.upload.progress = loaded
    },
    checkType(fileName) {
      const splitFileName = fileName.split('.')
      return splitFileName[splitFileName.length - 1]
    },
    async removeFile(index, fileId) {
      try {
        this.attachmentInstallment.splice(index, 1)
        this.form.attachmentInstallmentId.splice(index, 1)
        await api.other.deleteAttachment(fileId)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    downloadFile(item) {
      window.open(item.url)
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    subTotal(item) {
      let x = 0
      item.map(v => {
        if (v.amount) {
          x += parseFloat(v.amount) || 0
        }
      })
      return x
    }
  }
}
</script>

<style lang="scss">
.table-body {
  background-color: #E9FBF9;
}
.supporting-file p {
  font-size: 12px;
}

.background-file {
  background-color: #DBF9F6;
  border-radius: 16px;
}

.size-file {
  color: #D0C9D6;
}

.dropbox {
  border: 2px dashed #463191;
  padding: 40px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
  border-radius: 16px;
  text-align: center;
}

.input-file {
  margin-top: -40px;
  margin-left: -555px;
  opacity: 0;
  width: 100%;
  height: 280px;
  position: absolute;
  cursor: pointer;
}

.dropbox p {
  font-size: 12px;
  text-align: center;
  padding-top: 20px;
}

#text-dropbox {
  font-size: 16px;
  text-align: center;
}

.text-ellipsis {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropbox-files {
  border: 2px dashed #463191;
  padding: 10px 10px;
  min-height: 150px;
  position: relative;
  border-radius: 16px;
  text-align: center;
}

.card-list {
  display: grid;
  grid-gap: 2px;
}
</style>
